import { Col, Row } from 'antd';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import NotificationService from '../../Core/NotificationService'; // 'Core/NotificationService';
import queryString from 'query-string';
import { Redirect } from 'react-router';
import DashboardView from 'components/Dashboard/DashboardView';
import { CenteredFormContent, BannerDiv } from 'components/Layout/LoginLayout/LoginLayout.Style';

export interface Props extends RouteProps {
  children?: React.ReactNode;
}

export interface State {
  isConfirmed: boolean;
}

const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;

export default class DashboardPage extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    this.state = { isConfirmed: false };
  }

  componentDidMount() {
    const values = queryString.parse(this.props?.location?.search);

    //  this.confirmJointHolderFormHandler.ConfirmEmail(values.email, values.token).then(x => {
    //  NotificationService.success(
    //    'Email Confirmed',
    //    <>
    //      <p>
    //        Your email address has been confirmed.
    //      </p>
    //    </>, undefined, true
    //  );
    //  // setTimeout(() => { this.setState({ isConfirmed: true }); }, 15000);
    //  this.setState({ isConfirmed: true });

    //  return x;
    //});

    //let state: { from?: string; noPermission?: boolean } = {};
  }

  render() {
    return (<CenteredFormContent>
      <BannerDiv className='admin'>
        <Row style={{ height: '100%' }}>
          <Col xs={{ span: 10, offset: 11 }} md={{ span: 8, offset: 14 }} lg={{ span: 7, offset: 15 }} xxl={{ span: 7, offset: 16 }} style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
            <div>

            </div>
          </Col>
        </Row>
      </BannerDiv>
      <Row type="flex" align="middle" justify="center">
        <Col span={21} offset={1}>
          <DashboardView {...this.props} />
        </Col>
      </Row>

    </CenteredFormContent>);
  }
}










